import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/invite/')({
  validateSearch: (s: Record<string, unknown>) => ({
    token: typeof s.token === 'string' ? s.token : undefined,
  }),
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/invite/accept',
      search: { token: search.token },
      replace: true,
    });
  },
});
